export const headerIconHandler = status => {
    switch (status) {
        case 2:
            return 'clock'
        case 3:
            return 'check-circle'
        case 4:
            return 'block'
    }
}

export const iconHandler = status => {
    switch (status) {
        case 2:
            return 'clock'
        case 3:
            return 'check-circle'
        case 4:
            return 'block'
    }
}

export const classesHandler = status => {
    switch (status) {
        case 2:
            return 'warning'
        case 3:
            return 'positive'
        case 4:
            return 'secondary'
    }
}

export const colorHandler = status => {
    switch (status) {
        case 2:
            return 'var(--warning)'
        case 3:
            return 'var(--positive)'
        case 4:
            return 'var(--secondary)'
    }
}
